// Captura metadados de rastreamento no formulário público conforme a config do
// form (tracking_config): UTMs + click-ids + cookies do Meta + referrer + params
// EXTRAS definidos pelo cliente. Só lê o que está na página — nada sensível.
const UTM_KEYS = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_content',
  'utm_term',
];
const META_KEYS = [
  'campaign_id',
  'adset_id',
  'ad_id',
  'platform',
  'placement',
  'acquisition_owner',
];
const CLICK_IDS = ['gclid', 'fbclid'];

const readCookie = name => {
  const match = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`));
  return match ? decodeURIComponent(match[1]) : undefined;
};

export const captureTracking = (config = {}) => {
  const params = new URLSearchParams(window.location.search);
  const out = {};

  // UTMs + click-ids + cookies do Pixel (ligado por padrão).
  if (config.utm_enabled !== false) {
    [...UTM_KEYS, ...META_KEYS, ...CLICK_IDS].forEach(key => {
      const value = params.get(key);
      if (value) out[key] = value;
    });
    // Object.assign (em vez de out._fbp=) evita o no-underscore-dangle sem
    // desligar a regra; são os cookies do Pixel da Meta (nomes fixos).
    const fbp = readCookie('_fbp');
    if (fbp) Object.assign(out, { _fbp: fbp });
    const fbc = readCookie('_fbc');
    if (fbc) Object.assign(out, { _fbc: fbc });
  }

  // Origem (referrer).
  if (config.capture_referrer !== false && document.referrer) {
    out.referrer = document.referrer;
  }

  // Parâmetros extras definidos pelo cliente (ex.: manychat_id).
  (config.custom_params || []).forEach(param => {
    const key = typeof param === 'string' ? param : param && param.key;
    if (!key) return;
    const value = params.get(key);
    if (value) out[key] = value;
  });

  out.page_url = window.location.href;
  return out;
};
